<template>
  <div class="gameboard-compact">
    <b-loading :is-full-page="false" :active="isFinalising">
      <p class="title is-3 is-spaced">Finalising match ...</p>
    </b-loading>

    <div class="gameboard__content">
      <!-- GAME DATA MANAGER -->
      <slot></slot>

      <!-- TOP -->
      <div class="gameboard__top">
        <div
          class="gameboard__player is-flex is-justify-content-space-between is-align-items-center"
        >
          <GamePlayerInfo :game-data="gameData" :color="topColor" />
          <GameClock
            v-if="match.duration"
            :key="`${topColor}_clock`"
            :timeData="timeData[topColor]"
          />
        </div>
      </div>

      <!-- CENTER -->
      <div class="gameboard__center">
        <div class="gameboard__chessboard">
          <Chessboard
            ref="chessboard"
            :orientation="orientation"
            :pgn="pgn"
            :initialFen="initialFen"
            :movable="viewOnly ? '' : movable"
            :showThreats="viewThreats"
            :premove="gameSettings.premove"
            :autoQueen="gameSettings.autoQueen"
            @onAfterMove="handleAfterMove"
          />
        </div>
      </div>

      <!-- BOTTOM -->
      <div class="gameboard__bottom">
        <div
          class="gameboard__player is-flex is-justify-content-space-between is-align-items-center"
        >
          <GamePlayerInfo :game-data="gameData" :color="bottomColor" />
          <GameClock
            v-if="match.duration"
            :key="`${bottomColor}_clock`"
            :timeData="timeData[bottomColor]"
          />
        </div>
      </div>

      <div class="gameboard__message mt-2" v-if="!viewOnly">
        <GameMessage :game-data="gameData" :flippable="false" />
      </div>
    </div>

    <!-- PLAYERS/SIMULATORS -->
    <div v-if="!viewOnly">
      <GamePlayerFactory
        v-if="playerColor"
        :ref="topColor"
        :color="topColor"
        :player="topPlayer"
        :lastMove="lastMove"
        :key="matchId + '-top'"
      />
      <GamePlayerFactory
        v-if="playerColor"
        :ref="bottomColor"
        :color="bottomColor"
        :player="bottomPlayer"
        :lastMove="lastMove"
        :key="matchId + '-bottom'"
      />
    </div>
  </div>
</template>

<script>
import GameBoard from "@/components/games/GameBoard";
import Chessboard from "@/components/games/Chessboard";
import GamePlayerInfo from "@/components/games/compact/GamePlayerInfo";
import GameClock from "@/components/games/compact/GameClock";
import GamePlayerFactory from "@/components/games/GamePlayerFactory";
import GameMessage from "@/components/games/GameMessage";

export default {
  name: "GameBoard",

  extends: GameBoard,

  components: {
    Chessboard,
    GamePlayerInfo,
    GameClock,
    GamePlayerFactory,
    GameMessage,
  },

  props: {
    viewThreats: {
      type: Boolean,
      default: false,
    },
    viewOnly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      orientation: "white",
    };
  },
};
</script>

<style scoped>
.gameboard-compact {
  height: 100%;
  position: relative;
  padding-left: 6px;
}
.gameboard__content {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.gameboard__top {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 0.5;
  width: 100%;
  height: 100%;
}
.gameboard__center {
  padding: 15px 0 25px;
}
.gameboard__bottom {
  flex: 0.5;
}
</style>
